export default (isKiosk, idleTimeout, idleCountdown) => ({
    isKiosk,
    idleTimeout,
    idleCountdown,
    timeLeft: 0,
    countdownInterval: null,
    idleTimer: null,

    init() {
        this.timeLeft = this.idleTimeout

        this.$nextTick(() => {
            if (!this.isKiosk) return

            this.setIdleTimer()

            this.initEventListeners();
        })

    },

    initEventListeners() {
        const resetIdle = () => {
            if (this.$wire.opened) {
                return;
            }

            clearTimeout(this.idleTimer)
            clearInterval(this.countdownInterval)

            this.setIdleTimer();
        }

        ['mousemove', 'mousedown', 'keypress', 'keydown', 'scroll', 'touchstart']
            .forEach(event => {
                window.addEventListener(event, resetIdle, true)
            })
    },

    resetIdleTimer() {
        clearTimeout(this.idleTimer)
        clearInterval(this.countdownInterval)

        this.setIdleTimer()
    },

    setIdleTimer() {
        this.idleTimer = setTimeout(() => {
            this.$wire.opened = true
            this.timeLeft = this.idleCountdown
            this.countDown()

        }, this.idleTimeout * 1000)
    },

    countDown() {
        this.countdownInterval = setInterval(() => {
            if (this.timeLeft <= 0) {
                clearInterval(this.countdownInterval)

                this.$wire.logout()
            } else {
                this.timeLeft--
            }
        }, 1000)
    }
});
